export enum TryotoStatusList {
  new = 'Order created',
  paymentConfirmed = 'Payment confirmed',
  waitingAddressConfirmation = 'Waiting addressConfirmed',
  addressConfirmed = 'Address Confirmed',
  needConfirmation = 'Need Confirmation',
  paymentTypeConfirmed = 'Payment Type Confirmed',
  codOrderConfirmed = 'COD Order Confirmed',
  orderConfirmed = 'Order Confirmed',
  pickupFromStore = 'Pickup From Store',
  interDepotTransfer = 'Inter-Depot Transfer',
  canceled = 'Canceled',
  deleted = 'Deleted',
  readyForCollection = 'Ready for Collection',
  branchAssigned = 'Branch Assigned',
  assignedToWarehouse = 'Assigned to Warehouse',
  shipmentOnHoldWarehouse = 'Shipment On Hold (Warehouse)',
  shipmentOnHoldToCancel = 'Shipment On Hold to Cancel',
  notAvailableBR = 'Not Available (BR)',
  notAvailableWH = 'Not Available (WH)',
  picked = 'Picked',
  packed = 'Packed',
  searchingDriver = 'Searching Driver',
  shipmentCreated = 'Shipment Created',
  goingToPickup = 'Going to Pickup',
  arrivedPickup = 'Arrived at Pickup',
  pickedUp = 'Picked Up',
  arrivedDestinationTerminal = 'Arrived at Destination Terminal',
  arrivedTerminal = 'Arrived at Terminal',
  departedTerminal = 'Departed from Terminal',
  inTransit = 'In Transit',
  arrivedOriginTerminal = 'Arrived at Origin Terminal',
  outForDelivery = 'Out for Delivery',
  arrivedDestination = 'Arrived at Destination',
  shipmentInProgress = 'Shipment in Progress',
  undeliveredAttempt = 'Undelivered Attempt',
  shipmentOnHold = 'Shipment On Hold',
  delivered = 'Delivered',
  returned = 'Returned',
  returnProcessing = 'Return Processing',
  returnShipmentProcessing = 'Return Shipment Processing',
  reverseShipmentProcessing = 'Reverse Shipment Processing',
  reverseShipmentCreated = 'Reverse Shipment Created',
  reverseShipmentCanceled = 'Reverse Shipment Canceled',
  reverseGoingToPickup = 'Reverse Going to Pickup',
  reversePickedUp = 'Reverse Picked Up',
  reverseOutForDelivery = 'Reverse Out for Delivery',
  reverseArrivedTerminal = 'Reverse Arrived at Terminal',
  reverseDepartedTerminal = 'Reverse Departed from Terminal',
  reverseArrivedDestinationTerminal = 'Reverse Arrived at Destination Terminal',
  reverseUndeliveredAttempt = 'Reverse Undelivered Attempt',
  reverseShipmentOnHold = 'Reverse Shipment On Hold',
  reverseReturned = 'Reverse Returned',
  reverseConfirmReturn = 'Reverse Confirm Return',
  shipmentCanceled = 'Shipment Canceled',
  lostOrDamaged = 'Lost or Damaged',
  confirmedReturn = 'Confirmed Return',
  approved = 'Approved',
  rejected = 'Rejected',
  returnReverseComment = 'Return Reverse Comment',
  returnInitiated = 'Return Initiated',
  returnApproved = 'Return Approved',
  returnRejected = 'Return Rejected',
  awaitingCustomerResponse = 'Awaiting Customer Response',
  rescheduledDelivery = 'Rescheduled Delivery',
  damagedInTransit = 'Damaged in Transit',
  refundProcessing = 'Refund Processing',
  refundCompleted = 'Refund Completed',
  exchangeProcessing = 'Exchange Processing',
  exchangeCompleted = 'Exchange Completed',
  warehouseInspection = 'Warehouse Inspection',
  warehouseConfirmed = 'Warehouse Confirmed',
  awaitingRestock = 'Awaiting Restock',
  restocked = 'Restocked',
  orderReopened = 'Order Reopened',
  disputeRaised = 'Dispute Raised',
  disputeResolved = 'Dispute Resolved',
  disputeRejected = 'Dispute Rejected',
}
